module.exports = __webpack_public_path__ + "static/media/SE_Orddiktat.693f6c91.mp4";